interface IProps {
  address: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ReceiveViewContent = ({ address, onClickCopyBtn }: IProps) => {
  return (
    <div className="container-style2">
      <div className="main-content">
        <div className="qr-section">
          <div className="qr-image">
            <img
              src={`${import.meta.env.VITE_QR_CODE_URL}${address}`}
              alt="QR Code"
              style={{
                backgroundColor: 'white',
                padding: '10px',
              }}
            />
          </div>
          <div className="address">
            <span className="address-text">{address}</span>
            <button className="copy-button" onClick={onClickCopyBtn}>
              <i className="bi bi-files"></i>
            </button>
          </div>
          <p className="description">
            QR을 스캔하거나 주소를 복사해
            <br /> 상대방에게 공유해 주세요.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReceiveViewContent;
